export default __webpack_public_path__ + "static/media/Inter-Black.8d07d4e4.woff2";